import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Link } from "react-router-dom";

export default function Home() {
  return (
    <>
      <div className="bg-primary-dark">
        <div
          className="cover-image"
          style={{ minHeight: "300px", backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/home.jpg)` }}>
          <Container>
            <Row>
              <Col md={6}>
                <div className="d-flex h-100 align-items-center my-4">
                  <div>
                    <h1 className="font-title text-light mb-3">3DVizSNP</h1>
                    <hr className="border-white" />
                    <p className="lead text-light">
                      Visualize single nucleotide polymorphisms (SNPs) using iCn3d.
                    </p>
                    <Link to="/visualize" className="btn btn-outline-light text-decoration-none">
                      Visualize SNPs
                    </Link>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>

      <div className="bg-light py-4">
        <Container>
          <Row>
            <Col>
            <p>
              3DVizSNP enables rapid screening of mutations extracted from a variant caller format (VCF) file using the iCn3D protein structure and sequence viewing platform.  All you need is a VCF file and you’re ready to go!
            </p>

            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}
